

const Blog = {
  /**
   * Endpoint for admin create Blog.
   * @memberof Blog
   * @type {object}
   * @property {string} url - The URL for admin login.
   * @property {string} method - The HTTP method for create blogs (POST).
   */

  createBlog: {
    url: "/admin/create-blogs",
    method: "POST",
  },
    getBlogList: {
    url: "/admin/get-blogs",
    method: "GET",
  },
updateBlog: (id) => ({ 
    url: `/admin/update-blogs/${id}`,
  method: "PUT",
  }),
getBlogbyId: (id) => ({ 
    url: `/admin/get-blogs/${id}`,
    method: "GET",
  }),
getBlogBySlug: (slug) => ({ 
    url: `/user/get-blogs/${slug}`,
    method: "GET",
  }),
  deleteBlog: (id) => ({ 
    url: `/admin/delete-blogs/${id}`,
    method: "DELETE",
  }),
  uploadImage: {
   
    url: "/admin/upload-image",
    method: "POST",
  },
  updateBlogStatus: (id, status) => ({
    url: `/admin/${id}/${status}`,
    method: "POST",
  }),
};

export default Blog;